module.exports = __webpack_public_path__ + "static/media/waiting.0a0f6553.png";